module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e04-798178f7c893c5dc7e2ecf1417f36e6e.jpg";